import React from "react";
import { VideoPlayer } from "../videoplayer/VideoPlayer";
import { Seo } from "../seo/Seo";
import { InstagramFeedSection } from "../instagram/Instagram";
import "./Showreels.css";

export interface IShowreelsProps {}

export interface IShowreelsState {}

export class Showreels extends React.Component<
  IShowreelsProps,
  IShowreelsState
> {
  constructor(props: IShowreelsProps) {
    super(props);
    this.state = {};
  }

  public render() {
    return (
      <div className="vk-flex-container">
        <Seo
          title="Valere Kissi — Cinematographer & Photographer in Sioux Falls, SD"
          description="Valere Kissi is a cinematographer, director of photography, photographer, editor and colorist based in Sioux Falls, South Dakota. Watch the showreel."
          path="/"
        />
        <div className="reel-container">
          <h3 id="showreel-subtitle">SHOWREEL</h3>
          <VideoPlayer youtubeId="I7H17HDu8Ic"></VideoPlayer>
        </div>
        <InstagramFeedSection />
      </div>
    );
  }
}
